import React, { useState, useEffect, useCallback } from 'react';
import { InputText, ImageUpload, InputHtmlEditor } from 'components/common/input';
import BaseModalForm from 'components/common/modal/BaseModalForm';
import ImageGallery from 'components/admin/common/ImageGallery';
import { Alert } from 'react-bootstrap';
import { useFormHandlers } from 'core/hooks/form/formHandlers';
import { MODAL_FORM_ERRORS } from 'core/constant/MODAL_FORM_ERRORS';

const EditBlogModal = ({ show, blog, handleClose, handleSave, updating, errors, deleteMediaItem, requestError, initialImages }) => {
  const [formValues, setFormValues] = useState(blog);
  const [galleryImages, setGalleryImages] = useState(initialImages);
  const { handleChange, handleFileChangeLocal, handleRemoveImageLocal } = useFormHandlers(setFormValues);

  useEffect(() => {
    setFormValues(blog);
    setGalleryImages(blog?.media_item);
  }, [blog]);

  const handleSaveClick = useCallback(() => {
    handleSave({ ...formValues, id: blog?.id }, galleryImages);
  }, [formValues, blog?.id, handleSave, galleryImages]);

  return (
    <BaseModalForm show={show} title={blog?.id ? "Editar Blog" : "Crear Blog"} handleClose={handleClose} handleSave={handleSaveClick} updating={updating}>
      <div className="row">
        <div className="col-md-6 form-group">
          <InputText
            label="Título de la Sección"
            value={formValues?.section_title}
            onChange={(e) => handleChange('section_title', e.target.value)}
            placeholder="Ingrese el título de la sección"
            error={errors?.section_title}
          />
        </div>
        <div className="col-md-6 form-group">
          <InputText
            label="Subtítulo de la Sección"
            value={formValues?.section_subtitle}
            onChange={(e) => handleChange('section_subtitle', e.target.value)}
            placeholder="Ingrese el subtítulo de la sección"
            error={errors?.section_subtitle}
          />
        </div>
        <div className="col-md-6 form-group">
          <InputText
            label="Ruta del Blog"
            value={formValues?.slug}
            onChange={(e) => handleChange('slug', e.target.value)}
            placeholder="Ingrese la ruta"
            error={errors.slug}
          />
        </div>
        <div className="col-md-6 form-group">
          <ImageUpload
            label="Imagen del Blog"
            value={formValues?.src}
            onFileChange={(e) => handleFileChangeLocal(e, 'src')}
            onRemoveImage={() => handleRemoveImageLocal('src')}
            error={errors.src}
          />
        </div>
        <div className="col-12 form-group">
          <InputHtmlEditor
            label="Contenido del Blog"
            value={formValues?.content}
            onChange={(value) => handleChange('content', value)}
            placeholder="Ingrese el contenido del blog"
            error={errors.content}
            name="content"
          />
        </div>
        <div className="col-12 form-group">
          <h4>Galería de Imágenes de Blog</h4>
          <ImageGallery initialImages={galleryImages} onImagesChange={setGalleryImages} onDeleteImage={deleteMediaItem} />
        </div>
        <div className="col-12 form-group mt-3">
          {requestError &&
            <Alert variant="danger">
              {requestError?.response?.data?.message ||
               MODAL_FORM_ERRORS.BLOG}
            </Alert>
          }
        </div>
      </div>
    </BaseModalForm>
  );
};

export default React.memo(EditBlogModal);
